import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
        <div class="col00">
            <div class="heading01 type01">
                <h1>{{ 'report.Overview' | translate }}</h1>
            </div>

            <p class="filter-nav"><strong>{{ 'report.Quick view' | translate }}:</strong>
                <a ng-click="vm.changeDates('last30days')" ng-class="{'current': vm.selectedRange === 'last30days'}">{{ 'filter.Last 30 days' | translate }}</a>
                <a ng-click="vm.changeDates('thisWeek')" ng-class="{'current': vm.selectedRange === 'thisWeek'}">{{ 'filter.This week' | translate }}</a>
                <a ng-click="vm.changeDates('lastWeek')" ng-class="{'current': vm.selectedRange === 'lastWeek'}">{{ 'filter.Last week' | translate }}</a>
                <a ng-click="vm.changeDates('thisMonth')" ng-class="{'current': vm.selectedRange === 'thisMonth'}">{{ 'filter.This month' | translate }}</a>
                <a ng-click="vm.changeDates('lastMonth')" ng-class="{'current': vm.selectedRange === 'lastMonth'}">{{ 'filter.Last month' | translate }}</a>
                <a ng-click="vm.changeDates('last6Months')" ng-class="{'current': vm.selectedRange === 'last6Months'}">{{ 'filter.Last 6 months' | translate }}</a>
            </p>
            <reports-overview-filter
                sites="vm.sites"
                classifiers="vm.classifiers"
                filter="vm.filter"
                default-filter="vm.defaultFilter"
                list1="vm.metablocksList"
                list2="vm.deviceStatisticsList"
                list3="vm.learningCatalogueSearchesList"
                loading1="vm.metablocksLoading"
                loading2="vm.deviceStatisticsLoading"
                loading3="vm.learningCatalogueSearchesLoading"
                selected-range="vm.selectedRange"
            />
            <reports-overview-metablocks
                list="vm.metablocksList"
                loading="vm.metablocksLoading"
            />
            <reports-overview-devicestatistics
                list="vm.deviceStatisticsList"
                loading="vm.deviceStatisticsLoading"
            />
            <reports-overview-learningcatalogue
                list="vm.learningCatalogueSearchesList"
                loading="vm.learningCatalogueSearchesLoading"
            />
        </div>
    `
})
export default class {
    constructor (ReportOverviewResource, ClassifierResource, SiteResource, moment, ListFactory, $rootScope, lodash, toastr,
        TokenService
    ) {
        this.ReportOverviewResource = ReportOverviewResource;
        this.ClassifierResource = ClassifierResource;
        this.TokenService = TokenService;
        this.SiteResource = SiteResource;
        this.moment = moment;
        this.$rootScope = $rootScope;
        this.lodash = lodash;
        this.toastr = toastr;

        this.ListFactory = ListFactory;
        this.userId = this.TokenService.getUser().id;
    }

    $onInit () {
        this.metablocksLoading = true;
        this.deviceStatisticsLoading = true;
        this.learningCatalogueSearchesLoading = true;

        this.filter = {};
        this.filter.siteIds = [];
        this.classifiers = [];
        this.sites = [];

        this.loadClassifiers();
    }

    loadClassifiers () {
        this.ClassifierResource.query({ pageSize: 0 }).$promise
        .then(classifiers => {
            this.classifiers = classifiers;
            // load sites
            this.SiteResource.query({ reportOverviewSites: true, pageSize: 0 }).$promise
            .then(sites => {
                this.sites = sites;
                this.lodash.forEach(this.sites, site => {
                    this.filter.siteIds.push(site.id);
                });

                this.defaultFilter = angular.copy(this.filter);

                this.$rootScope.$broadcast('overviewReport:classifiersLoaded');
                this.initData();
            });
        });
    }

    initData () {
        this.selectedRange = localStorage.getItem(`${this.userId}_selectedRange`)
            ? localStorage.getItem(`${this.userId}_selectedRange`)
            : 'last30days';
        this.changeDates(this.selectedRange);
    }

    changeDates (range) {
        this.selectedRange = range;
        localStorage.setItem(`${this.userId}_selectedRange`, range);
        const now = this.moment(); // Using moment.js for date handling
        switch (range) {
        case 'last30days':
            this.from = now.clone().subtract(30, 'days').startOf('day').format('YYYY-MM-DD');
            this.to = now.endOf('day').format('YYYY-MM-DD');
            break;
        case 'thisWeek':
            this.from = now.clone().startOf('isoWeek').format('YYYY-MM-DD'); // Monday start
            this.to = now.endOf('isoWeek').format('YYYY-MM-DD'); // Sunday end
            break;
        case 'lastWeek':
            this.from = now.clone().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
            this.to = now.clone().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD');
            break;
        case 'thisMonth':
            this.from = now.clone().startOf('month').format('YYYY-MM-DD');
            this.to = now.endOf('month').format('YYYY-MM-DD');
            break;
        case 'lastMonth':
            this.from = now.clone().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
            this.to = now.clone().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            break;
        case 'last6Months':
            this.from = now.clone().subtract(6, 'months').startOf('month').format('YYYY-MM-DD');
            this.to = now.endOf('month').format('YYYY-MM-DD');
            break;
        default:
            return;
        }

        this.filter.from = this.from;
        this.filter.to = this.to;
        this.defaultFilter.from = this.from;
        this.defaultFilter.to = this.to;

        this.loadReports();
    }

    loadReports () {
        this.loadMetablocks();
        this.loadDeviceStatistics();
        this.loadLearningCatalogueSearches();
    }

    loadMetablocks () {
        this.metablocksLoading = true;
        this.metablocksList = this.ListFactory.createWithoutPagination(this.ReportOverviewResource.getMetablocks.bind(this.ReportOverviewResource));
        this.metablocksList.fetch({}, this.filter).then(() => {
            this.metablocksLoading = false;
        }).catch((response) => {
            this.toastr.error(response.data[0].message);
            this.metablocksLoading = false;
        }).finally(() => {

        });
    }

    loadDeviceStatistics () {
        this.deviceStatisticsLoading = true;
        this.deviceStatisticsList = this.ListFactory.createWithoutPagination(this.ReportOverviewResource.getDeviceStatistics.bind(this.ReportOverviewResource));
        this.deviceStatisticsList.fetch({}, this.filter).then(() => {
            this.deviceStatisticsLoading = false;
        }).catch((response) => {
            this.toastr.error(response.data[0].message);
            this.deviceStatisticsLoading = false;
        }).finally(() => {

        });
    }

    loadLearningCatalogueSearches () {
        this.learningCatalogueSearchesLoading = true;
        this.learningCatalogueSearchesList = this.ListFactory.createWithoutPagination(this.ReportOverviewResource.getLearningCatalogueSearches.bind(this.ReportOverviewResource));
        this.learningCatalogueSearchesList.fetch({}, this.filter).then(() => {
            this.learningCatalogueSearchesLoading = false;
        }).catch((response) => {
            this.toastr.error(response.data[0].message);
            this.learningCatalogueSearchesLoading = false;
        }).finally(() => {

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/reports/overview/index.js